var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdlogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CHOOSE-ICON"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.3333 26.9889V11.3333C28.3333 11.22 28.1732 0 14.2545 0H13.7006L13.566 0.536917C12.5106 4.75858 10.7001 6.23617 7.92908 7.35958C6.55349 7.91633 5.66524 9.21258 5.66524 10.6604V12.75H14.7163C13.5887 17.4491 9.95208 19.7257 7.80866 20.6833C6.50674 21.2627 5.66524 22.5406 5.66524 23.936V26.9889C4.05024 27.3176 2.83191 28.7484 2.83191 30.4583V34H31.1667V30.4583C31.1667 28.747 29.9483 27.3176 28.3333 26.9889ZM8.38666 21.9767C10.9126 20.8491 15.2972 18.0738 16.2817 12.1578L16.4192 11.3333H7.08333V10.6604C7.08333 9.792 7.62449 9.01142 8.46174 8.67283C11.373 7.49275 13.5731 5.7885 14.7999 1.42233C26.7353 1.69433 26.9167 10.9367 26.9181 11.3333V26.9167H7.08333V23.936C7.08333 23.0987 7.59333 22.3295 8.38666 21.9767ZM29.75 32.5833H4.24999V30.4583C4.24999 29.2867 5.20341 28.3333 6.37499 28.3333H27.625C28.7966 28.3333 29.75 29.2867 29.75 30.4583V32.5833Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdlogo4);
export default __webpack_public_path__ + "static/media/idlogo4.2c03cbefd39acb235d043fa77dad7827.svg";
export { ForwardRef as ReactComponent };